<template>
  <div id="app" class="Product-Sans">
    <!-- Product-Sans -->
    <div class="header">
      <headerComponent
        v-on:toggleSideBar="toggleSideBar"
        :isToggleSideBar="sidebar"
      >
      </headerComponent>
    </div>
    <!-- <br> -->
    <div class="router-view">
      <router-view />
    </div>
  </div>
</template>

<script>
import headerComponent from "./components/headerComponent.vue";
export default {
  data() {
    return {
      // token: window.localStorage.getItem("access-token") || false, // TOKEN
      theme: JSON.parse(window.localStorage.getItem("theme")).theme,
      sidebar: JSON.parse(window.localStorage.getItem("sidebar")).sidebar,
    };
  },
  components: {
    headerComponent,
  },
  mounted() {
    // SET THE THEME FROM LOCAL STORAGE
    if (this.theme === "default") {
      // change theme
      window.document.documentElement.style.setProperty(
        "--bg-color-dark",
        "black"
      );
      window.document.documentElement.style.setProperty(
        "--primary-color",
        "#10ac84"
      );
      window.document.documentElement.style.setProperty("--dan-ger", "#ff0000");

      // set a border on clicked btn
    } else if (this.theme === "pink") {
      // change theme
      window.document.documentElement.style.setProperty(
        "--bg-color-dark",
        "#0c2461"
      );
      window.document.documentElement.style.setProperty(
        "--primary-color",
        "#f53b57"
      );
      window.document.documentElement.style.setProperty("--dan-ger", "#ff0000");

      // set a border on clicked btn
    } else if (this.theme === "red") {
      // change theme
      window.document.documentElement.style.setProperty(
        "--bg-color-dark",
        "black"
      );
      window.document.documentElement.style.setProperty(
        "--primary-color",
        "red"
      );
      window.document.documentElement.style.setProperty("--dan-ger", "#e84118");

      // set a border on clicked btn
    } else if (this.theme === "brown") {
      // change theme
      window.document.documentElement.style.setProperty(
        "--bg-color-dark",
        "#c23616"
      );
      window.document.documentElement.style.setProperty(
        "--primary-color",
        "#e84118"
      );
      window.document.documentElement.style.setProperty("--dan-ger", "#ff0000");
    } else if (this.theme === "blue") {
      // change theme
      window.document.documentElement.style.setProperty(
        "--bg-color-dark",
        "#152238"
      );
      window.document.documentElement.style.setProperty(
        "--primary-color",
        "#1c2e4a"
      );
      window.document.documentElement.style.setProperty("--dan-ger", "#ff0000");
    }

    // SET SIDEBAR STATE
    setTimeout(() => {
      const sidebar = window.document.querySelector(".side-bar");

      if (this.sidebar == true) {
        // Show Sidebar
        // console.log(sidebar);
        sidebar.classList.add("display-block");
        sidebar.classList.remove("display-none");
        // SET CHECKBOX TO CHECKED
      } else if (this.sidebar == false) {
        // Hide Sidebar
        sidebar.classList.remove("display-block");
        sidebar.classList.add("display-none");
        // SET CHECKBOX TO UNCHECKED
      }
    }, 3000);

    // SET MODE OF THE APP (DARK/LIGHT)
  },
  methods: {
    toggleSideBar: (isChecked) => {
      const sidebar = window.document.querySelector(".side-bar");
      if (isChecked) {
        sidebar.classList.add("display-block");
        sidebar.classList.remove("display-none");

        // save changes on local storage
        window.localStorage.setItem(
          "sidebar",
          JSON.stringify({ sidebar: true })
        );
      } else {
        sidebar.classList.remove("display-block");
        sidebar.classList.add("display-none");

        // save changes on local storage
        window.localStorage.setItem(
          "sidebar",
          JSON.stringify({ sidebar: false })
        );
      }
    },
    toggleMode: (isChecked) => {
      if (isChecked) {
        // Set Mode To Dark

        // save changes on local storage
        window.localStorage.setItem("mode", JSON.stringify({ mode: true }));
      } else {
        // Set to current theme by Localstorage

        // save changes on local storage
        window.localStorage.setItem("mode", JSON.stringify({ mode: false }));
      }
    },
  },
};
</script>

<style>
@import url("./assets/fontawesome/css/all.css");

:root {
  --main-btn-color: #1e3799;

  --bg-color-dark: black;
  --bg-color-darker: rgba(0, 0, 0, 0.93);
  --text-color: rgba(0, 0, 0, 0.79);
  --ads-color: #0c2461;
  --dan-ger: #ff0000;
  --succ-ess: #05c46b;
  --primary-color: #f53b57;
  --blue-bell: ;
  --war-ning: #fa8231;
}
#app {
  /*font-family: "Avenir", Helvetica, Arial, sans-serif;*/
  /*font-family: "Product Sans";*/
  /*font-family: 'Quicksand', sans-serif;*/
  /*font-family: 'Nunito', sans-serif;*/
  /*font-family: 'Titillium Web', sans-serif;/********* Best One **********/
  /*font-family: 'Noto Sans JP', sans-serif;*/
  /*font-family: 'Nunito Sans', sans-serif;*/
  font-family: "Barlow", sans-serif; /********** (Best One , Choosen One) **********/
  /*font-family: 'Inconsolata', monospace; /*********** Best One *************/
  /*font-family: 'Karla', sans-serif;*/
  /*font-family: 'Abel', sans-serif;*/
  /*font-family: 'Questrial', sans-serif;*/
  /*font-family: 'Rajdhani', sans-serif;*/
  /*font-family: 'Didact Gothic', sans-serif;*/
  font-weight: bolder;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.router-view {
  padding-top: 60px;
}
.btns {
  background-color: var(--main-btn-color);
  color: white;
}
#rl {
  color: white !important;
}
.shadow {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2), 0 4px 18px 0 rgba(0, 0, 0, 0.1) !important;
}
.header {
  position: fixed;
  width: 100%;
  z-index: 999;
}
.dark-mode {
  background-color: #152238 !important;
  color: white !important;
}

#nav a.router-link-exact-active {
  /*color: #42b983;*/
  color: white;
}
</style>
